module.exports = __webpack_public_path__ + "fcc-static/media/dplus.49736c384ffdf02042610f9cfd57f4d7.svg";